import {
  addDays,
  buildMeses,
  formatDate,
  formatReal,
  getDate,
  loadMasks,
  showModal,
} from '../functions';

import Dropzone from '../vendor/dropzone';

Dropzone.autoDiscover = false;
Dropzone.prototype.defaultOptions.dictDefaultMessage = 'Arraste arquivo(s) aqui ou clique para fazer upload.';
Dropzone.prototype.defaultOptions.dictFallbackMessage = 'Seu navegador não permite envio de arquivos.';
Dropzone.prototype.defaultOptions.dictFallbackText = 'Please use the fallback form below to upload your files like in the olden days.';
Dropzone.prototype.defaultOptions.dictFileTooBig = 'Arquivo é muito grande ({{filesize}}MB). Máximo permitido: {{maxFilesize}}MB.';
Dropzone.prototype.defaultOptions.dictInvalidFileType = 'Você não pode enviar arquivos neste formato.';
Dropzone.prototype.defaultOptions.dictResponseError = 'Servidor respondeu com código de status {{statusCode}}.';
Dropzone.prototype.defaultOptions.dictCancelUpload = 'Cancelar upload';
Dropzone.prototype.defaultOptions.dictCancelUploadConfirmation = 'Tem certeza que deseja cancelar este upload?';
Dropzone.prototype.defaultOptions.dictRemoveFile = 'Remover arquivo';
Dropzone.prototype.defaultOptions.dictMaxFilesExceeded = 'Você não pode enviar mais arquivos.';

const escapeHtml = value => $('<div>').text(value ?? '').html();

class Empresa {

  static getDados(url) {
    return $.ajax({
      url,
    }).always(() => {
      $('.preloader').hide();
    });
  };

  static getContatos($this) {
    $('.preloader').show();
    $.when(Empresa.getDados(`/clientes/${ $this.val() }/contatos`)).done(response => {
      const title = `
          <h3>${ escapeHtml(response.razao_social) }</h3>
          <p class="mb-0">
            <strong class="pr-2">CNPJ</strong>${ escapeHtml(response.cnpj) }
            <br><strong class="pr-2">CCM</strong>${ escapeHtml(response.ccm) }
          </p>
        `;

      let contatos = [];
      response.contatos.forEach(contato => {
          contatos.push(`<tr>
              <th class="w-30">
                ${ contato.contato ? escapeHtml(contato.contato) : '<em>Não informado</em>' }
              </th>
              <td>
                ${ contato.email ? `<div><span class="mdi mdi-email"></span> <a href="mailto:${ encodeURIComponent(contato.email) }" title="Abrir no Cliente de Email">${ escapeHtml(contato.email) }</a></div>` : '' }
                ${ contato.celular ? `<div><span class="mdi mdi-cellphone-basic"></span> ${ escapeHtml(contato.celular) }</div>` : '' }
                ${ contato.whatsapp ? `<div><span class="mdi mdi-whatsapp"></span> ${ escapeHtml(contato.whatsapp) }</div>` : '' }
                ${ contato.telefone ? `<div><span class="mdi mdi-phone"></span> ${ escapeHtml(contato.telefone) }</div>` : '' }
              </td>
            </tr>`);
        },
      );

      const notFound = '<tr><td class="alert alert-info text-center">Não há informações de contatos...</td></tr>';
      const body = `
        <h3><span class="mdi mdi-email"></span> Dados de Contato</h3>
        <table class="table table-bordered">
          <tbody>
            ${ contatos.length > 0 ? contatos.join('') : notFound }
          </tbody>
        </table>
        `;

      showModal(title, body);
    });
  }

  static getSocio($this) {
    $('.preloader').show();

    $.when(Empresa.getDados(`/clientes/${ $this.data('id') }/socio`)).done(socio => {
        const title = `
           <h4>
            ${ escapeHtml(socio.nome) }
            ${ socio.socio_responsavel === 'S' ? '<span class="badge badge-purple">Responsável</span>' : '' }
            <span class="badge badge-success">${ socio.participacao / 100 }%</span>
          </h4>
        `;

        const regime = socio.empresa.regime;

        let socios = [];
        socios.push(`
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">CPF</strong>${ escapeHtml(socio.cpf) }</li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">PIS</strong>${ socio.pis ? escapeHtml(socio.pis) : '--' }</li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">INSS</strong>${ formatReal(regime.aliquota * socio.prolabore, true) }</li>
        `);

        const body = `
        <h3><span class="mdi mdi-account"></span> Informações do Sócio</h3>
        <table class="table table-bordered">
          <tbody>
            <tr><th>Nome</th><td>${ escapeHtml(socio.nome) }</td></tr>
            <tr>
              <th>Endereço</th>
              <td>
                  ${ socio.cep ? escapeHtml(socio.cep) : '' } ${ socio.endereco ? ': ' + escapeHtml(socio.endereco) : '' } ${ socio.numero ? ', ' + escapeHtml(socio.numero) : '' } ${ socio.complemento ? ' - ' + escapeHtml(socio.complemento) : '' } ${ socio.bairro ? ' / ' + escapeHtml(socio.bairro) : '' } ${ socio.cidade ? ' - ' + escapeHtml(socio.cidade) : '' }${ socio.estado ? '/' + escapeHtml(socio.estado) : '' }
              </td>
            </tr>
            <tr>
              <th>Naturalidade</th><td>${ socio.naturalidade ? escapeHtml(socio.naturalidade) : '' }</td>
            </tr>
            <tr>
              <th>Nacionalidade</th><td>${ socio.nacionalidade ? escapeHtml(socio.nacionalidade) : '' }</td>
            </tr>
            <tr>
              <th>RG</th>
              <td>
                ${ socio.rg ? escapeHtml(socio.rg) : '' } ${ socio.rg_expedicao && socio.rg_expedicao !== '0000-00-00' ? ' - ' + formatDate(socio.rg_expedicao) : '' }
              </td>
            </tr>
            <tr>
              <th>Data de Nascimento</th>
              <td>${ socio.data_nascimento && socio.data_nascimento !== '0000-00-00' ? formatDate(socio.data_nascimento) : '' }</td>
            </tr>
            <tr>
              <th>CPF</th><td>${ socio.cpf ? escapeHtml(socio.cpf) : '' }</td>
            </tr>
            <tr>
              <th>PIS</th><td>${ socio.pis ? escapeHtml(socio.pis) : '' }</td>
            </tr>
            <tr>
              <th>Título de  Eleitor</th><td>${ socio.titulo ? escapeHtml(socio.titulo) : '' }</td>
            </tr>
            <tr>
              <th>Nome da Mãe</th><td>${ socio.mae ? escapeHtml(socio.mae) : '' }</td>
            </tr>
            <tr>
              <th>Nome do Pai</th><td>${ socio.pai ? escapeHtml(socio.pai) : '' }</td>
            </tr>
            <tr>
              <th>Estado Civil</th><td>${ socio.estado_civil ? escapeHtml(socio.estado_civil) : '' }</td>
            </tr>
            <tr>
              <th>Regime de Casamento</th><td>${ socio.regime_casamento ? escapeHtml(socio.regime_casamento) : '' }</td>
            </tr>
            <tr>
              <th>Profissão</th><td>${ socio.profissao ? escapeHtml(socio.profissao) : '' }</td>
            </tr>
            <tr>
              <th>Participação</th>
              <td>${ socio.participacao ? socio.participacao / 100 : '' } ${ socio.participacao_tipo == 'percentual' ? '%' : 'Q' }</td>
            </tr>
            <tr>
              <th>Sócio Administrador</th>
              <td>${ socio.administrador === 'S' ? 'Sim' : 'Não' }</td>
            </tr>
            <tr>
              <th>Pró-labore</th>
              <td>${ socio.prolabore_possui === 'S' ? 'Sim' : 'Não' }</td>
            </tr>
            <tr>
              <th><span class="mdi mdi-subdirectory-arrow-right"> Valor Base</th>
              <td>${ socio.prolabore ? formatReal(socio.prolabore) : '' }</td>
            </tr>
            <tr>
              <th><span class="mdi mdi-subdirectory-arrow-right"> Recolhimento</th>
              <td>${ socio.prolabore_inicio && socio.prolabore_inicio !== '0000-00-00' ? 'Início: ' + formatDate(socio.prolabore_inicio) : '' } ${ socio.prolabore_fim && socio.prolabore_fim !== '0000-00-00' ? ' - Fim: ' + formatDate(socio.prolabore_fim) : '' }</td>
            </tr>
            <tr><th>DARF</th><td>${ socio.darf_possui === 'S' ? 'Sim' : 'Não' }</td></tr>
            <tr>
              <th><span class="mdi mdi-subdirectory-arrow-right"> Valor</th>
              <td>${ socio.darf ? formatReal(socio.darf) : '' }</td>
            </tr>
            <tr>
              <th><span class="mdi mdi-subdirectory-arrow-right"> Recolhimento</th>
              <td>${ socio.darf_inicio && socio.darf_inicio !== '0000-00-00' ? 'Início: ' + formatDate(socio.darf_inicio) : '' } ${ socio.darf_fim && socio.darf_fim !== '0000-00-00' ? ' - Fim: ' + formatDate(socio.darf_fim) : '' }</td>
            </tr>
            <tr>
              <th>Responsável Receita</th>
              <td>${ socio.socio_responsavel === 'S' ? 'Sim' : 'Não' }</td>
            </tr>
            <tr>
              <th>Email</th>
              <td>${ socio.email ? escapeHtml(socio.email) : '' }</td>
            </tr>
            <tr>
              <th>Telefone</th>
              <td>${ socio.telefone ? escapeHtml(socio.telefone) : '' }</td>
            </tr>
          </tbody>
        </table>
        `;
        showModal(title, body);
      },
    )
    ;
  }

  static getSocios($this) {
    $('.preloader').show();
    $.when(Empresa.getDados(`/clientes/${ $this.val() }/socios`)).done(response => {
      const title = `
          <h3>${ escapeHtml(response.razao_social) }</h3>
          <p class="mb-0">
            <strong class="pr-2">CNPJ</strong>${ escapeHtml(response.cnpj) }
            <br><strong class="pr-2">CCM</strong>${ escapeHtml(response.ccm) }
          </p>
        `;

      const regime = response.regime;
      let socios = [];

      response.socios.forEach(socio => {
          socios.push(`
              <li class="list-group-item py-3">
              <h4>
                ${ escapeHtml(socio.nome) }
                ${ socio.socio_responsavel === 'S' ? '<span class="badge badge-purple">Responsável</span>' : '' }
                <span class="badge badge-success">${ socio.participacao / 100 } ${ socio.participacao_tipo === 'quota' ? 'Q' : '%' }</span>
              </h4>
              </li>
              <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">CPF</strong>${ escapeHtml(socio.cpf) }</li>
              <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">PIS</strong>${ socio.pis ? escapeHtml(socio.pis) : '--' }</li>
              <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">INSS</strong>${ formatReal(regime.aliquota * socio.prolabore, true) }</li>
            `);
        },
      );

      const body = `
        <h3><span class="mdi mdi-account"></span> Quadro Societário</h3>
        <ul class="list-group">
            ${ socios.length > 0 ? socios.join('') : '<li class="list-group-item"><div class="alert alert-info text-center">Não há informações de sócios...</div></li>' }
        </ul>
        `;
      showModal(title, body);
    });
  }

  static getCredenciais($this) {
    $('.preloader').show();

    $.when(Empresa.getDados(`/clientes/${ $this.val() }/credenciais`)).done(response => {
      const title = `
          <h3>${ response.razao_social }</h3>
          <p class="mb-0">
            <strong class="pr-2">CNPJ</strong>${ response.cnpj }
            <br><strong class="pr-2">CCM</strong>${ response.ccm }
          </p>
        `;

      let cpfResponsavel = '';
      response.socios.forEach(socio => {
        if (socio.socio_responsavel === 'S') cpfResponsavel = socio.cpf;
      });

      const body = `
        <h3><span class="mdi mdi-asterisk"></span> Informações Seguras</h3>
        <ul class="list-group">
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">CNPJ</strong>${ response.cnpj }</li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">IE</strong>${ response.ie }</li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">CCM</strong>${ response.ccm }</li>
          <li class="list-group-item">
              <strong class="d-inline-block w-30 pr-2">Localização</strong>
              ${ response.cidade } ${ response.estado ? ` / ${ response.estado }` : '' }
              ${ response.cidade + response.estado === '' ? '--' : '' }
          </li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">CPF Responsável</strong>${ cpfResponsavel }</li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">Senha Prefeitura</strong>${ response.senha_prefeitura }</li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">Acesso Simples</strong>${ response.acesso_simples }</li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">Certificado Digital</strong>${ response.certificado_digital === 'S' ? 'Sim' : 'Não' }</li>
          <li class="list-group-item"><strong class="d-inline-block w-30 pr-2">Senha Certificado</strong>${ response.senha_certificado_digital ? response.senha_certificado_digital : '<em>Não se aplica!</em>' }</li>
        </ul>
        `;

      showModal(title, body);
    });
  }

  static getOcorrencias($this) {
    $('.preloader').show();

    $.when(Empresa.getDados(`/clientes/${ $this.val() }/ocorrencias`)).done(response => {
      const title = `
              <h3>${ response.razao_social }</h3>
              <p class="mb-0">
                <strong class="pr-2">CNPJ</strong>${ response.cnpj }
                <br><strong class="pr-2">CCM</strong>${ response.ccm }
              </p>
            `;

      const ocorrencias = [];

      response.ocorrencias.forEach(ocorrencia => {
        let status;
        switch (ocorrencia.status) {
          default:
            status = 'border';
            break;
          case 'Pendente':
            status = 'danger';
            break;
          case 'Em Espera':
            status = 'orange';
            break;
          case 'Em Andamento':
            status = 'warning';
            break;
          case 'Visualizada':
            status = 'info';
            break;
          case 'Finalizada':
            status = 'success';
            break;
          case 'Cancelada':
            status = 'dark';
            break;
          case 'Pausada':
            status = 'dark';
            break;
        }
        ocorrencias.push(`<tr>
                    <td>
                        <strong>
                        ${ formatDate(ocorrencia.data) } -
                        ${ ocorrencia.origem === 'outros' ? ocorrencia.origem_outros : response.origens[ocorrencia.origem] ?? 'Origem Não-informada' }
                        </strong>
                        <br>
                        <span class="badge badge-${ status }">${ ocorrencia.status ? ocorrencia.status : 'Não-Rastreada' }</span>
                        ${ ocorrencia.ocorrencia.replace(/\r/, '').replace(/\n\n/g, '\n').replace(/\n/g, '<br>') }
                      </td>
                  </tr>`,
        );
      });

      const body = `
                <h3><span class="mdi mdi-view-list"></span> Ocorrências</h3>
                <table class="table table-bordered">
                  <tbody>
                    ${ ocorrencias.length > 0 ? ocorrencias.join('') : '<tr><td><div class="alert alert-info text-center">Não há registros...</div></td></tr>' }
                  </tbody>
                </table>
            `;

      showModal(title, body);
    });
  }

  static getInformacaoes($this) {
    $('.preloader').show();
    $.when(Empresa.getDados(`/clientes/${ $this.val() }/informacoes`)).done(response => {
      const title = `
          <h3>${ response.razao_social }</h3>
          <p class="mb-0">
            <strong class="pr-2">CNPJ</strong>${ response.cnpj }
            <br><strong class="pr-2">CCM</strong>${ response.ccm }
          </p>
        `;

      const body = `
        <h3><span class="mdi mdi-information"></span> Informações Principais</h3>
        <table class="table table-bordered">
          <tbody>
            <tr><th class="w-30">Responsável Fiscal</th><td>${ response.responsavel ? response.responsavel.nome : 'Não informado' }</td></tr>
            <tr><th class="w-30">Responsável DP</th><td>${ response.responsavel_dp ? response.responsavel_dp.nome : 'Não informado' }</td></tr>
            <tr><th class="w-30">CNPJ</th><td>${ response.cnpj }</td></tr>
            <tr><th class="w-30">Razão Social</th><td>${ response.razao_social }</td></tr>
            <tr><th class="w-30">IE</th><td>${ response.ie }</td></tr>
            <tr><th class="w-30">CCM</th><td>${ response.ccm }</td></tr>
            <tr>
              <th class="w-30">Localização</th>
              <td>
                ${ response.cidade } ${ response.estado ? ` / ${ response.estado }` : '' }
                ${ response.cidade + response.estado === '' ? '--' : '' }
              </td>
            </tr>
            <tr><th class="w-30">Regime Tributário</th><td>${ response.regime.regime_tributario }</td></tr>
            <tr><th class="w-30">Impugnaçao</th><td>${ response.impugnacao }</td></tr>
            <tr><th class="w-30">Data Vencimento</th><td>${ response.data_vencimento }</td></tr>
            <tr><th class="w-30">Mensalidade</th><td>${ formatReal(response.valor_mensalidade, true) }</td></tr>
            <tr><th class="w-30">Pagamentos</th><td>${ response.pagamento.pagamento }</td></tr>
            <tr><th class="w-30">Observações</th><td>${ response.observacoes ? response.observacoes.replace('\n', '<br>') : '' }</td></tr>
          </tbody>
        </table>
        `;

      showModal(title, body);
    });
  }

  static salvarEmpresa($this) {
    const $id = $('#id');
    const $upload_id = $('#upload_id');
    const $status = $('#status');
    const $razao_social = $('#razao_social');
    const $cep = $('#cep');
    const $endereco = $('#endereco');
    const $numero = $('#numero');
    const $complemento = $('#complemento');
    const $bairro = $('#bairro');
    const $cidade = $('#cidade');
    const $estado = $('#estado');
    const $cnpj = $('#cnpj');
    const $nire = $('#nire');
    const $ccm = $('#ccm');
    const $ie = $('#ie');
    const $natureza_juridica = $('#natureza_juridica');
    const $sigla_porte = $('#sigla_porte');
    const $hubcount = $('#hubcount');
    const $dmed = $('#dmed');
    const $dimob = $('#dimob');
    const $codigos_iss = $('#codigos_iss');
    const $regime_tributario = $('#regime_tributario');
    const $anexo1 = $('#anexo1');
    const $anexo2 = $('#anexo2');
    const $anexo3 = $('#anexo3');
    const $anexo4 = $('#anexo4');
    const $impugnacao = $('#impugnacao');
    const $acesso_simples = $('#acesso_simples');
    const $acesso_ecac = $('#acesso_ecac');
    const $usuario_posto_fiscal = $('#usuario_posto_fiscal');
    const $senha_posto_fiscal = $('#senha_posto_fiscal');
    const $senha_prefeitura = $('#senha_prefeitura');
    const $responsavel_receita = $('#responsavel_receita');
    const $certificado_digital = $('#certificado_digital');
    const $senha_certificado_digital = $('#senha_certificado_digital');
    const $certificado_tipo = $('#certificado_tipo');
    const $certificado_com_cliente = $('#certificado_com_cliente');
    const $emissao_certificado = $('#emissao_certificado');
    const $expiracao_certificado = $('#expiracao_certificado');
    const $capital_social = $('#capital_social');
    const $folha_pagamento = $('#folha_pagamento');
    const $inicio_atividades = $('#inicio_atividades');
    const $inicio_servicos = $('#inicio_servicos');
    const $fim_servicos = $('#fim_servicos');
    const $motivo_inativacao = $('#motivo_inativacao');
    const $observacoes = $('#observacoes');
    const $contabilidade_nome = $('#contabilidade_nome');
    const $contabilidade_telefone = $('#contabilidade_telefone');
    const $contabilidade_email = $('#contabilidade_email');
    const $contabilidade_data = $('#contabilidade_data');
    const $responsavel = $('#responsavel');
    const $data_responsavel = $('#data_responsavel');
    const $responsavel_dp = $('#responsavel_dp');
    const $data_responsavel_dp = $('#data_responsavel_dp');
    const $pagamento_preferencial = $('#pagamento_preferencial');
    const $ciclo_pagamento = $('#ciclo_pagamento');
    const planos = [
      $('#plano_PJM').is(':checked') ? 'PJM' : '',
      $('#plano_FREE').is(':checked') ? 'FREE' : '',
      $('#plano_NF1').is(':checked') ? 'NF1' : '',
      $('#plano_NF3').is(':checked') ? 'NF3' : '',
      $('#plano_NF5').is(':checked') ? 'NF5' : '',
      $('#plano_NFP').is(':checked') ? 'NFP' : '',
      $('#plano_MON').is(':checked') ? 'MON' : '',
      $('#plano_ESC').is(':checked') ? 'ESC' : '',
      $('#plano_MAX').is(':checked') ? 'MAX' : '',
    ];
    const $valor_mensalidade = $('#valor_mensalidade');
    const $finalizado_data = $('#finalizado_data');

    $('.preloader').show();

    const cnaeIds = [];
    $('[data-cnae-id]').each(function () {
      cnaeIds.push(Number($(this).data('cnaeId')));
    });

    $.ajax({
      type: 'POST',
      url: $this.prop('action'),
      data: {
        id: parseInt($id.val()),
        upload_id: $upload_id.val(),
        status: $status.length > 0 ? ($status.is(':checked') ? 'S' : 'N') : 'S',
        razao_social: $razao_social.val(),
        cep: $cep.val(),
        endereco: $endereco.val(),
        numero: $numero.val(),
        complemento: $complemento.val(),
        bairro: $bairro.val(),
        cidade: $cidade.val(),
        estado: $estado.val(),
        cnpj: $cnpj.val(),
        nire: $nire.val(),
        ccm: $ccm.val(),
        ie: $ie.val(),
        natureza_juridica: $natureza_juridica.val(),
        sigla_porte: $sigla_porte.val(),
        hubcount: $hubcount.val(),
        cnae_ids: cnaeIds,
        dmed: $dmed.is(':checked') ? 'S' : 'N',
        dimob: $dimob.is(':checked') ? 'S' : 'N',
        codigos_iss: $codigos_iss.val(),
        regime_tributario: $regime_tributario.val(),
        anexo1: $anexo1.val(),
        anexo2: $anexo2.val(),
        anexo3: $anexo3.val(),
        anexo4: $anexo4.val(),
        impugnacao: $impugnacao.val(),
        acesso_simples: $acesso_simples.val(),
        acesso_ecac: $acesso_ecac.val(),
        usuario_posto_fiscal: $usuario_posto_fiscal.val(),
        senha_posto_fiscal: $senha_posto_fiscal.val(),
        senha_prefeitura: $senha_prefeitura.val(),
        responsavel_receita: $responsavel_receita.val(),
        certificado_digital: $certificado_digital.val(),
        certificado_com_cliente: $certificado_com_cliente.is(':checked') ? 'S' : 'N',
        senha_certificado_digital: $senha_certificado_digital.val(),
        certificado_tipo: $certificado_tipo.val(),
        emissao_certificado: $emissao_certificado.val(),
        expiracao_certificado: $expiracao_certificado.val(),
        capital_social: $capital_social.val().replace(/\./g, '').replace(',', '.'),
        folha_pagamento: $folha_pagamento.val(),
        inicio_atividades: $inicio_atividades.val(),
        inicio_servicos: $inicio_servicos.val(),
        fim_servicos: $fim_servicos.val(),
        motivo_inativacao: $motivo_inativacao.val(),
        observacoes: $observacoes.val(),
        contabilidade_nome: $contabilidade_nome.val(),
        contabilidade_telefone: $contabilidade_telefone.val(),
        contabilidade_email: $contabilidade_email.val(),
        contabilidade_data: $contabilidade_data.val(),
        responsavel: $responsavel.val(),
        data_responsavel: $data_responsavel.val(),
        responsavel_dp: $responsavel_dp.val(),
        data_responsavel_dp: $data_responsavel_dp.val(),
        dados_socios: $('#dados_socios').val(),
        dados_contatos: $('#dados_contatos').val(),
        dados_anexos: $('#dados_anexos').val(),
        pagamento_preferencial: $pagamento_preferencial.val(),
        valor_mensalidade: $valor_mensalidade.val(),
        ciclo_pagamento: $ciclo_pagamento.val(),
        plano: ';' + planos.join(';') + ';',
        finalizado_data: $finalizado_data.is(':checked') ? 'S' : 'N',
      },
    }).done(response => {
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: `O cliente foi salvo com sucesso.`,
      });
      window.dadosSocios = {};
      window.dadosContatos = {};
      $('#dados_socios').val('');
      $('#dados_contatos').val('');
      window.location = `/clientes/${ response.id }/alterar`;
    }).fail(response => {

      let errorHTML = response.responseText;

      let hasCNPJ = false;
      let CNPJMessage = '';

      if (response.status === 412) {

        const errors = (response.responseJSON.errors);

        if (+$id.val() == 0 && errors['cnpj'] && errors['cnpj'] != 'Informe o CNPJ') {
          hasCNPJ = true;
          CNPJMessage = `<div class="alert alert-danger text-danger">${ errors['cnpj'] }</div>`;
        }

        let messages = [];
        let $firstFocus = null;

        for (let error in errors) {
          if (!$firstFocus) {
            $firstFocus = $(`#${ error }`);
          }
          $(`#${ error }`).closest('.form-group').addClass('invalid-data');
          messages.push(`<li>${ errors[error] }</li>`);
        }

        const acao = parseInt($id.val()) === 0 ? 'cadastrar' : 'alterar';

        errorHTML = `
                    Não foi possível ${ acao } a empresa.
                    <br>Verifique os campos em vermelho.
                `;
      }

      if (hasCNPJ) {
        errorHTML = CNPJMessage;
      }

      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: errorHTML,
      });
    }).always(() => {
      $('.preloader').hide();
    });
  }

  static fillModalSocio(dadosSocio) {

    const html = $('#templateSocio').html().replace(/_socio_/g, `socio_`);
    const
      body = `
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                 <form id="formSocio" class="floating-labels mt-4">
                   <input type="hidden" id="editSocioId" value="${ dadosSocio ? dadosSocio.socio_id : 'N' }">
                  ${ html }
                 </form>
               </div>
             </div>
           </div>
         </div>
      `;

    const
      footer = `
        <div>
        <button class="btn btn-primary btn-rounded text-white aplicar-socio">Aplicar</button>
        </div>
      `;

    const acaoTitle = dadosSocio ? 'Alterar' : 'Adicionar';

    showModal(`<h3>${ acaoTitle } Sócio</h3>`, body, footer);

    $('.modal-dialog').css('max-width', '800px');

    if (dadosSocio) {
      for (let inputName in dadosSocio) {
        switch (inputName) {
          case 'socio_prolabore_valor':
            $(`#socio_prolabore_valor`).val(formatReal(dadosSocio[inputName]));
            break;
          case 'socio_darf_valor':
            $(`#socio_darf_valor`).val(formatReal(dadosSocio[inputName]));
            break;
          case 'socio_prolabore_possui':
            $(`#socio_prolabore`).val(dadosSocio[inputName]);
            break;
          case 'socio_darf_possui':
            $(`#socio_darf`).val(dadosSocio[inputName]);
            break;
          default:
            $(`#${ inputName }`).val(dadosSocio[inputName]);
            break;
        }
        const $input = $(`#${ inputName }`);
        let action = $input.prop('type') !== 'date' && (!$input.val() || $input.val().length === 0) ? 'removeClass' : 'addClass';
        $input.closest('.form-group')[action]('focused');
      }
    }

    $('[type="date"]').closest('.form-group').addClass('focused');
    $('select').closest('.form-group').addClass('focused');
  }

  static getModalSocio(dadosSocio, idSocio) {

    const idEmpresa = parseInt($('#id').val());

    /**
     * Se tiver dadosSocio significa que já foi editado,
     * e não pode buscar no servidor novamente.
     */
    if (!dadosSocio && idSocio && idEmpresa > 0) {
      $('.preloader').show();
      $.ajax({
        url: `/socios/${ idSocio }`,
      }).done(response => {

        let dadosSocio = {};

        for (let key in response) {

          const value = response[key];

          if (key === 'id') continue;
          if (key === 'data_nascimento') key = 'nascimento';
          if (key === 'darf') key = 'darf_valor';
          if (key === 'prolabore') key = 'prolabore_valor';
          if (key === 'participacao') value = value / 100;

          dadosSocio[`socio_${ key }`] = value;
        }

        window.dadosSocios[idSocio] = dadosSocio;

        Empresa.fillModalSocio(dadosSocio);
        $('#editSocioId').val(idSocio);
        $('.preloader').hide();
      });
    } else {
      Empresa.fillModalSocio(dadosSocio);
    }
  }

  static aplicarSocio() {
    const $socio_nome = $('#socio_nome');
    const $socio_cep = $('#socio_cep');
    const $socio_endereco = $('#socio_endereco');
    const $socio_numero = $('#socio_numero');
    const $socio_complemento = $('#socio_complemento');
    const $socio_bairro = $('#socio_bairro');
    const $socio_cidade = $('#socio_cidade');
    const $socio_estado = $('#socio_estado');
    const $socio_naturalidade = $('#socio_naturalidade');
    const $socio_nacionalidade = $('#socio_nacionalidade');
    const $socio_regime_casamento = $('#socio_regime_casamento');
    const $socio_estado_civil = $('#socio_estado_civil');
    const $socio_profissao = $('#socio_profissao');
    const $socio_rg = $('#socio_rg');
    const $socio_rg_expedicao = $('#socio_rg_expedicao');
    const $socio_nascimento = $('#socio_nascimento');
    const $socio_cpf = $('#socio_cpf');
    const $socio_mae = $('#socio_mae');
    const $socio_pai = $('#socio_pai');
    const $socio_participacao = $('#socio_participacao');
    const $socio_participacao_tipo = $('#socio_participacao_tipo');
    const $socio_administrador = $('#socio_administrador');
    const $socio_prolabore = $('#socio_prolabore'); // prolabore_possui no DB
    const $socio_prolabore_valor = $('#socio_prolabore_valor');
    const $socio_prolabore_inicio = $('#socio_prolabore_inicio');
    const $socio_prolabore_fim = $('#socio_prolabore_fim');
    const $socio_darf = $('#socio_darf');
    const $socio_darf_valor = $('#socio_darf_valor');
    const $socio_darf_inicio = $('#socio_darf_inicio');
    const $socio_darf_fim = $('#socio_darf_fim');
    const $socio_socio_responsavel = $('#socio_socio_responsavel');
    const $socio_pis = $('#socio_pis');
    const $socio_titulo = $('#socio_titulo');
    const $socio_email = $('#socio_email');
    const $socio_telefone = $('#socio_telefone');

    let errors = { length: 0 };

    if ($socio_nome.val().length === 0) {
      errors['socio_nome'] = 'Informe o nome do sócio';
      errors.length++;
    }

    if ($socio_cpf.val().length === 0) {
      errors['socio_cpf'] = 'Informe o cpf do sócio';
      errors.length++;
    }

    if (errors.length > 0) {

      let messages = [];
      let $firstFocus = null;

      for (let error in errors) {
        if (!$firstFocus) {
          $firstFocus = $(`#${ error }`);
        }
        $(`#${ error }`).closest('.form-group').addClass('invalid-data');
        messages.push(`<li>${ errors[error] }</li>`);
      }

      const errorHTML = `
          Não foi possível aplicar o sócio.
          <br>Verifique os campos em vermelho.
        `;

      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: errorHTML,
      });
      return false;
    }

    let idSocio = `_add_${ Math.floor(Math.random() * 1000000000000) }`;
    const editSocioId = $('#editSocioId').val();
    if (editSocioId !== 'N') {
      idSocio = editSocioId;
    }

    const dadosSocio = {
      socio_id: idSocio,
      socio_nome: $socio_nome.val(),
      socio_cep: $socio_cep.val(),
      socio_endereco: $socio_endereco.val(),
      socio_numero: $socio_numero.val(),
      socio_complemento: $socio_complemento.val(),
      socio_bairro: $socio_bairro.val(),
      socio_cidade: $socio_cidade.val(),
      socio_estado: $socio_estado.val(),
      socio_naturalidade: $socio_naturalidade.val(),
      socio_nacionalidade: $socio_nacionalidade.val(),
      socio_regime_casamento: $socio_regime_casamento.val(),
      socio_estado_civil: $socio_estado_civil.val(),
      socio_profissao: $socio_profissao.val(),
      socio_rg: $socio_rg.val(),
      socio_rg_expedicao: $socio_rg_expedicao.val(),
      socio_nascimento: $socio_nascimento.val(),
      socio_cpf: $socio_cpf.val(),
      socio_mae: $socio_mae.val(),
      socio_pai: $socio_pai.val(),
      socio_participacao: $socio_participacao.val().length === 0 ? 0 : $socio_participacao.val(),
      socio_participacao_tipo: $socio_participacao_tipo.val(),
      socio_administrador: $socio_administrador.val(),
      socio_prolabore_possui: $socio_prolabore.val(),
      socio_prolabore_valor: $socio_prolabore_valor.val(),
      socio_prolabore_inicio: $socio_prolabore_inicio.val(),
      socio_prolabore_fim: $socio_prolabore_fim.val(),
      socio_darf: $socio_darf.val(),
      socio_darf_valor: $socio_darf_valor.val(),
      socio_darf_inicio: $socio_darf_inicio.val(),
      socio_darf_fim: $socio_darf_fim.val(),
      socio_socio_responsavel: $socio_socio_responsavel.val(),
      socio_pis: $socio_pis.val(),
      socio_titulo: $socio_titulo.val(),
      socio_email: $socio_email.val(),
      socio_telefone: $socio_telefone.val(),
    };

    window.dadosSocios[`${ idSocio }`] = dadosSocio;
    $('#dados_socios').val(JSON.stringify(window.dadosSocios));

    const socio = `
      <div class="d-flex w-100 justify-content-between">
        <div>
          ${ escapeHtml(dadosSocio.socio_nome) }
          <span class="badge badge-success">
            ${ dadosSocio.socio_participacao }
            ${ dadosSocio.socio_participacao_tipo === 'quota' ? 'Q' : '%' }
          </span>
          ${ dadosSocio.socio_socio_responsavel === 'S' ? '<span class="badge badge-purple">Responsável</span>' : '' }
        </div>
        <div>
          <a title="Alterar Sócio" href="javascript:void(0);" class="alterar-socio"
             data-id="${ idSocio }">
            <span class="mdi mdi-pencil "></span>
            <span class="sr-only">Alterar</span>
          </a>
          <a title="Excluir Sócio" href="javascript:void(0);" class="excluir-socio"
             data-id="${ idSocio }">
            <span class="mdi mdi-trash-can"></span>
            <span class="sr-only">Excluir</span>
          </a>
        </div>
      </div>
    `;

    if (editSocioId !== 'N') {
      $(`[data-id=${ editSocioId }]`).closest('LI').html(socio);
    } else {
      $('#listaSocios').append(`<li class="list-group-item">${ socio }</li>`);
      $('#listaSocios').removeClass('d-none');
    }

    $('#modal').modal('hide');
  }

  static excluirSocio($socio) {
    Swal.fire({
      title: 'Tem certeza?',
      text: 'Você não poderá reverte esta operação!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, exclua!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Importante!',
          icon: 'warning',
          html: 'O sócio foi marcado para exclusão. <br>Clique em "Salvar Cliente" para aplicar.',
        });

        const id = $socio.data('id').toString().replace(/_remove_|_edit_|_add_/, '');

        if (dadosSocios[`_edit_${ id }`]) {
          delete dadosSocios[`_edit_${ id }`];
        }

        if (dadosSocios[`_add_${ id }`]) {
          delete dadosSocios[`_add_${ id }`];
        }

        // 12 é local, < 11 veio do servidor
        if (id.length < 12) {
          dadosSocios[`_remove_${ id }`] = true;
        }

        window.dadosSocios = dadosSocios;

        $('#dados_socios').val(JSON.stringify(dadosSocios));
        $socio.closest('li').remove();
      }
    });
  }

  static fillModalContato(dadosContato) {

    const html = $('#templateContato').html().replace(/_contato_/g, `contato_`);

    const
      body = `
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                 <form id="formContato" class="floating-labels mt-4">
                   <input type="hidden" id="editContatoId" value="${ dadosContato ? dadosContato.contato_id : 'N' }">
                  ${ html }
                 </form>
               </div>
             </div>
           </div>
         </div>
      `;

    const
      footer = `
        <div>
        <button class="btn btn-primary btn-rounded text-white aplicar-contato">Aplicar</button>
        </div>
      `;

    const acaoTitle = dadosContato ? 'Adicionar' : 'Alterar';

    showModal(`<h3>${ acaoTitle } Contato</h3>`, body, footer);

    $('.modal-dialog').css('max-width', '800px');

    if (dadosContato) {
      for (let inputName in dadosContato) {
        $(`#${ inputName }`).val(dadosContato[inputName]);
        const $input = $(`#${ inputName }`);
        let action = $input.prop('type') !== 'date' && (!$input.val() || $input.val().length === 0) ? 'removeClass' : 'addClass';
        $input.closest('.form-group')[action]('focused');
      }
    } else {
      $('[type="date"]').closest('.form-group').addClass('focused');
      $('select').closest('.form-group').addClass('focused');
    }
  }

  static getModalContato(dadosContato, idContato) {

    const idEmpresa = parseInt($('#id').val());

    /**
     * Se tiver dadosContato significa que já foi editado,
     * e não pode buscar no servidor novamente.
     */
    if (!dadosContato && idContato && idEmpresa > 0) {
      $('.preloader').show();
      $.ajax({
        url: `/contatos/${ idContato }`,
      }).done(response => {

        let dadosContato = {};

        for (let key in response) {

          const value = response[key];

          if (key === 'id') continue;
          if (key === 'contato') key = 'nome';

          dadosContato[`contato_${ key }`] = value;
        }

        window.dadosContatos[idContato] = dadosContato;

        Empresa.fillModalContato(dadosContato);
        $('#editContatoId').val(idContato);
        $('.preloader').hide();
      });
    } else {
      Empresa.fillModalContato(dadosContato);
    }
  }

  static aplicarContato() {

    const $contato_nome = $('#contato_nome');
    const $contato_email = $('#contato_email');
    const $contato_telefone = $('#contato_telefone');
    const $contato_celular = $('#contato_celular');
    const $contato_whatsapp = $('#contato_whatsapp');

    const values = $contato_email.val() + $contato_telefone.val() + $contato_celular.val() + $contato_whatsapp.val();

    if (values.trim().length === 0) {

      const errorHTML = `
          Não foi possível aplicar o contato.
          <br>Informe pelo menos 1 email, telefone, celular ou whatsapp.
        `;

      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: errorHTML,
      });
      return false;
    }

    let idContato = `_add_${ Math.floor(Math.random() * 1000000000000) }`;
    const editContatoId = $('#editContatoId').val();
    if (editContatoId !== 'N') {
      idContato = editContatoId;
    }

    const dadosContato = {
      contato_id: idContato,
      contato_nome: $contato_nome.val(),
      contato_email: $contato_email.val(),
      contato_telefone: $contato_telefone.val(),
      contato_celular: $contato_celular.val(),
      contato_whatsapp: $contato_whatsapp.val(),
    };

    window.dadosContatos[`${ idContato }`] = dadosContato;
    $('#dados_contatos').val(JSON.stringify(window.dadosContatos));

    const contato = `
      <th>
        ${ escapeHtml(dadosContato.contato_nome) }
        ${ dadosContato.contato_nome.trim().length === 0 ? '<em>Não informado</em>' : '' }
      </th>
      <td>
        <div class="d-flex w-100 justify-content-between">
          <div class="info-contato">
            ${ dadosContato.contato_email ? `<div><span class="mdi mdi-email"></span> ${ escapeHtml(dadosContato.contato_email) }</div>` : '' }
            ${ dadosContato.contato_celular ? `<div><span class="mdi mdi-cellphone-basic"></span> ${ escapeHtml(dadosContato.contato_celular) }</div>` : '' }
            ${ dadosContato.contato_whatsapp ? `<div><span class="mdi mdi-whatsapp"></span> ${ escapeHtml(dadosContato.contato_whatsapp) }</div>` : '' }
            ${ dadosContato.contato_telefone ? `<div><span class="mdi mdi-phone"></span> ${ escapeHtml(dadosContato.contato_telefone) }</div>` : '' }
          </div>
          <div class="acoes-contato">
            <a title="Alterar Contato" href="javascript:void(0);" class="alterar-contato"
               data-id="${ dadosContato.contato_id }">
              <span class="mdi mdi-pencil "></span>
              <span class="sr-only">Alterar</span>
            </a>
            <a title="Excluir Contato" href="javascript:void(0);" class="excluir-contato"
               data-id="${ dadosContato.contato_id }">
              <span class="mdi mdi-trash-can"></span>
              <span class="sr-only">Excluir</span>
            </a>
          </div>
        </div>
      </td>
    `;

    if (editContatoId !== 'N') {
      $(`[data-id=${ editContatoId }]`).closest('tr').html(contato);
    } else {
      $('#listaContatos').append(`<tr>${ contato }</tr>`);
      $('#listaContatos').closest('table').removeClass('d-none');
    }

    $('#modal').modal('hide');
  }

  static excluirContato($contato) {
    Swal.fire({
      title: 'Tem certeza?',
      text: 'Você não poderá reverte esta operação!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, exclua!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Importante!',
          icon: 'warning',
          html: 'O contato foi marcado para exclusão. <br>Clique em "Salvar Cliente" para aplicar.',
        });

        const id = $contato.data('id').toString().replace(/_remove_|_edit_|_add_/, '');

        if (dadosContatos[`_edit_${ id }`]) {
          delete dadosContatos[`_edit_${ id }`];
        }

        if (dadosContatos[`_add_${ id }`]) {
          delete dadosContatos[`_add_${ id }`];
        }

        // 12 é local, < 11 veio do servidor
        if (id.length < 12) {
          dadosContatos[`_remove_${ id }`] = true;
        }

        window.dadosContatos = dadosContatos;

        $('#dados_contatos').val(JSON.stringify(dadosContatos));
        $contato.closest('tr').remove();
      }
    });
  }

  static getModalAnexo(categoria, hashCategoria) {

    $(document).on('click', '#fecharModalAnexos', function () {
      window.location.replace(window.location.href.split('#')[0] + '#' + hashCategoria);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    });

    showModal(`<h3>Adicionar Anexo</h3>`, false, false, '#modalDropzone');

    $('.modal-dialog').css('max-width', '800px');

    if ($('#form-anexos').hasClass('dz-clickable')) return false;

    new Dropzone('#form-anexos', {
      maxFilesize: 100, // MB
      maxFiles: 10,
      init: function () {
        this.on('sending', function (file, xhr, formData) {
          formData.append('upload_id', $('#upload_id').val());
          formData.append('categoria', categoria);
        });
        this.on('success', function (file, response) {
          const { id, filename } = response;
          $('#listaAnexos').append(`
            <li class="list-group-item">
              <div class="d-flex justify-content-between w-100">
                <a href="/uploads/${ encodeURIComponent(filename) }" target="_blank">${ escapeHtml(file.name) }</a>
                <a title="Excluir Anexo" href="javascript:void(0);" class="excluir-anexo"
                   data-id="${ escapeHtml(id) }">
                  <span class="mdi mdi-trash-can"></span>
                  <span class="sr-only">Excluir</span>
                </a>
              </div>
            </li>
          `).removeClass('d-none');
        });
      },
    });
  }

  static excluirAnexo($anexo) {
    Swal.fire({
      title: 'Tem certeza?',
      text: 'Você não poderá reverte esta operação!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, exclua!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Importante!',
          icon: 'warning',
          html: 'O anexo foi marcado para exclusão. <br>Clique em "Salvar Cliente" para aplicar.',
        });

        const id = $anexo.data('id');

        dadosAnexos[`_remove_${ id }`] = true;

        window.dadosAnexos = dadosAnexos;

        $('#dados_anexos').val(JSON.stringify(dadosAnexos));
        $anexo.closest('li').remove();
      }
    });
  }

  static getModalAdicionarFaturamento($this) {

    const idEmpresa = $this.val();
    const mes = $this.data('mes');
    const ano = $this.data('ano');
    const valor = $this.data('valor');

    const title = `
     <h3>${ escapeHtml($('#nomeTitle').text() || $this.closest('TR').find('td').eq(0).text()) }</h3>
     <h6>${ escapeHtml($('#cnpjTitle').text() || $this.closest('TR').find('td').eq(1).text()) }</h6>
    `;

    let mensagemValor = '';
    let acaoBotao = 'Adicionar';

    if (parseInt(valor) > 0) {
      mensagemValor = `<p class="alert alert-info">O faturamento deste mês já foi informado: R$ <strong class="money-mask">${ valor }</strong></p>`;
      acaoBotao = '<strong>Modificar</strong>';
    }
    const body = `
        ${ mensagemValor }
      <form class="floating-labels mt-5 mb-4">
        <div class="row">
          <div class="form-group col-3">
            <select class="form-control custom-select p-0" id="mesFaturamento">
              <option value="1">01</option>
              <option value="2">02</option>
              <option value="3">03</option>
              <option value="4">04</option>
              <option value="5">05</option>
              <option value="6">06</option>
              <option value="7">07</option>
              <option value="8">08</option>
              <option value="9">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
            <span class="bar"></span>
            <label for="mesFaturamento">Mês</label>
          </div>
          <div class="form-group col-md-3">
            <input type="number" step="1" class="form-control" id="anoFaturamento" value="${ ano }">
            <span class="bar"></span>
            <label for="anoFaturamento">Ano</label>
          </div>
          <div class="form-group col-md-6">
            <input type="text" class="form-control money-mask" id="valorFaturamento" >
            <span class="bar"></span>
            <label for="valorFaturamento" autofocus>Valor</label>
          </div>
        </div>
      </form>
    `;

    const footer = `
      <button type="button" class="btn btn-primary text-white btn-rounded aplicar-faturamento" value="${ idEmpresa }">${ acaoBotao } Faturamento</button>
    `;

    showModal(title, body, footer);

    $('#mesFaturamento').val(mes);
    $('input, select').closest('.form-group').addClass('focused');
  }

  static aplicarFaturamento($this) {
    $this.prop('disabled', true);

    if ($('#empresa').length > 0) {
      $('.preloader').show();
    }

    $.ajax({
      type: 'POST',
      url: `/faturamentos`,
      data: {
        empresa_id: $('.aplicar-faturamento').val(),
        mes: $('#mesFaturamento').val(),
        ano: $('#anoFaturamento').val(),
        valor: $('#valorFaturamento').val().replace(/\./g, '').replace(',', '.'),
      },
    }).done(response => {
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: `O faturamento foi adicionado com sucesso.`,
      });
      window.location.reload();
    }).fail(response => {
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        html: `Ocorreu um erro ao salvar o faturamento.`,
      });
    }).always(() => {
      $this.prop('disabled', false);
      $('.preloader').hide();
    });
  }

  static salvarFaturamentos() {

    const data = {
      mes: $('#mes').val(),
      ano: $('#ano').val(),
      valores: [],
    };

    $('.valor-faturamento').each(function () {
      data.valores.push({
        id: $(this).data('id'),
        valor: $(this).val().replace(/\./g, '').replace(',', '.'),
      });
    });

    $('.preloader').show();

    $.ajax({
      type: 'POST',
      url: `/faturamentos/lote`,
      data,
    }).done(response => {
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: `Os faturamentos foram adicionados com sucesso.`,
      });
      $('#modal').modal('hide');
    }).fail(response => {
      let errorHTML = response.responseText;

      if (response.status === 412) {

        const errors = (response.responseJSON.errors);

        let messages = [];
        let $firstFocus = null;

        for (let error in errors) {
          if (!$firstFocus) {
            $firstFocus = $(`#${ error }`);
          }
          $(`#${ error }`).closest('.form-group').addClass('invalid-data');
          messages.push(`<li>${ errors[error] }</li>`);
        }

        errorHTML = `
            Não foi possível cadastrar o faturamento.
            <br>Verifique os campos em vermelho.
          `;
      }

      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: errorHTML,
      });
    }).always(() => {
      $('.preloader').hide();
    });
  }

  static doVerFaturamentos(faturamentos, $this) {

    let empresa = $('#nomeTitle').text();
    let cnpj = $('#cnpjTitle').text();

    if (!empresa) {
      empresa = $this.closest('tr').find('td').eq(0).text().trim();
      cnpj = $this.closest('tr').find('td').eq(1).text().trim();
    }

    const title = `
     <h3>${ escapeHtml(empresa) }</h3>
     <h6>${ escapeHtml(cnpj) }</h6>
    `;

    const footer = ``;

    const date = new Date();
    const mesAtual = date.getMonth() + 1;
    let anoAtual = date.getFullYear();
    let valorAtual = 0;
    let faturamentoAnual = 0;
    let minAno = anoAtual;

    for (let ano in faturamentos) {
      if (ano < parseInt(minAno)) {
        minAno = parseInt(ano);
      }
    }

    if (faturamentos[anoAtual]) {
      valorAtual = parseFloat(faturamentos[anoAtual][mesAtual]);

      for (let mes in faturamentos[anoAtual]) {
        faturamentoAnual += parseFloat(faturamentos[anoAtual][mes]);
      }
    }

    const anosOptions = [];

    let i = anoAtual;
    while (i >= minAno) {
      anosOptions.push(`<option value="${ i }" ${ i === anoAtual ? 'selected' : '' }>${ i }</option>`);
      i--;
    }

    const body = `
      <div class="text-center">
        <div class="input-group">
          <div class="input-group-prepend">
            <button type="button" class="btn btn-secondary trocar-mes-faturamento anterior">
              <span class="mdi mdi-arrow-left-bold"></span>
            </button>
          </div>
          <select class="custom-select" id="mesFaturamento" style="width: 100px!important;">
            ${ buildMeses(mesAtual) }
          </select>
          <select class="custom-select" id="anoFaturamento" style="width: 100px!important;">
            ${ anosOptions.reverse().join('') }
          </select>
          <div class="input-group-append">
            <button type="button" class="btn btn-secondary trocar-mes-faturamento proximo">
              <span class="mdi mdi-arrow-right-bold"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="pt-5">
        <strong>Faturamento Anual (para o ano selecionado): </strong>
        <input type="text" class="form-control money-mask" id="valorFaturamentoAnual" placeholder="0,00" readonly>
      </div>
      <div class="pt-1 pb-5">
        <strong>Faturamento Últimos 12 Meses (exceto o mês selecionado): </strong>
        <input type="text" class="form-control money-mask" id="valorFaturamento12Meses" placeholder="0,00" readonly>
      </div>
      <table class="table table-bordered mb-5">
        <tbody>
          <tr>
            <th>Valor do Mês</th>
            <td>
              <input type="text" class="form-control money-mask" id="valorFaturamento" placeholder="0,00" readonly>
            </td>
          </tr>
        </tbody>
      </table>
    `;

    showModal(title, body, footer);

    let idCliente = $('#id').val();

    if (!idCliente) {
      idCliente = $this.val();
      window.lastIdCliente = idCliente;
    }

    $.ajax({
      type: 'POST',
      url: location.origin + '/faturamentos/ver/' + parseInt(idCliente) + '/' + anoAtual + '/' + mesAtual,
    }).done(function (response) {
      $('#valorFaturamentoAnual').val(response.faturamentoAnual.toFixed(2).toString()).trigger('input');
      $('#valorFaturamento12Meses').val(response.valorFaturamento12Meses.toFixed(2).toString()).trigger('input');
      $('#valorFaturamento').val(response.valorAtual.toFixed(2).toString()).trigger('input');
    });
  }

  static verFaturamentos($this) {

    $('.preloader').show();

    $.ajax({
      url: `/clientes/${ $this.val() }/faturamentos`,
    }).done(response => {
      window.faturamentosCliente = response;
      Empresa.doVerFaturamentos(response, $this);
    }).always(() => {
      $('.preloader').hide();
    });
  }

  static updateMesFaturamento(anterior, $this) {

    const primeiroAno = parseInt($('#anoFaturamento option').eq(0).val());
    const ultimoAno = parseInt($('#anoFaturamento option').eq($('#anoFaturamento option').length - 1).val());

    let mes = parseInt($('#mesFaturamento').val());
    let ano = parseInt($('#anoFaturamento').val());

    if ($this.prop('tagName') === 'BUTTON') {
      if (anterior) {
        mes--;
        if (mes === 0) {
          mes = 12;
          ano--;
        }
      } else {
        mes++;
        if (mes === 13) {
          mes = 1;
          ano++;
        }
      }

      if (ano > ultimoAno) {
        ano = primeiroAno;
      }

      if (ano < primeiroAno) {
        ano = ultimoAno;
      }
    }

    $('#mesFaturamento').val(mes);
    $('#anoFaturamento').val(ano);

    let idCliente = $('#id').val();

    if (!idCliente) {
      idCliente = window.lastIdCliente;
    }

    $.ajax({
      type: 'POST',
      url: location.origin + '/faturamentos/ver/' + parseInt(idCliente) + '/' + ano + '/' + mes,
    }).done(function (response) {
      $('#valorFaturamentoAnual').val(response.faturamentoAnual.toFixed(2).toString()).trigger('input');
      $('#valorFaturamento12Meses').val(response.valorFaturamento12Meses.toFixed(2).toString()).trigger('input');
      $('#valorFaturamento').val(response.valorAtual.toFixed(2).toString()).trigger('input');
    });
  }

  static getModalAdicionarOcorrencia(idEmpresa) {

    const title = `
             <h3>${ escapeHtml($('#nomeTitle').text()) }</h3>
             <h6>${ escapeHtml($('#cnpjTitle').text()) }</h6>
        `;

    const usuarios = window.usuarios;
    const optionsUsuarios = [];
    usuarios.forEach(usuario => {
        const selected = window.idUsuario === usuario.id ? 'selected' : '';
        optionsUsuarios.push(`
                  <option value="${ usuario.id }" ${ selected }>${ escapeHtml(usuario.nome) }</option>`,
        );
      },
    );

    const body = `
          <form class="floating-labels mt-5 mb-4">
            <div class="form-group mb-5 d-none1">
              <select class="form-control custom-select p-0" id="usuarioOcorrencia">
                <option value="-1">Todos</option>
                ${ optionsUsuarios.join('') }
              </select>
              <span class="bar"></span>
              <label for="usuarioOcorrencia">Responsável</label>
            </div>
            <div class="form-group mb-5">
              <select class="form-control custom-select p-0" id="statusOcorrencia">
                <option value="Não-Rastreada">Não-Rastreada</option>
                <option value="Em Andamento">Em Andamento</option>
                <option value="Pendente" selected>Pendente</option>
                <option value="Em Espera">Em Espera</option>
                <option value="Cancelada">Cancelada</option>
                <option value="Pausada">Pausada</option>
                <option value="Finalizada">Finalizada</option>
                <option value="Bloqueada">Bloqueada</option>
              </select>
              <span class="bar"></span>
              <label for="statusOcorrencia">Status</label>
            </div>
            <div class="form-group mb-5">
              <select class="form-control custom-select p-0" id="origemOcorrencia">
                <option value="nenhuma" selected="">Selecione</option>
                <option value="empresa-entrada">Entrada de empresa (abertura e transferência)</option>
                <option value="empresa-saida">Saída de empresa (encerramento e transferência)</option>
                <option value="servico-suspensao">Suspensão de serviço (Ex: por débitos)</option>
                <option value="alteracao-regime">Alteração de regime tributário</option>
                <option value="emissao-certificado">Emissao de Certificado digital</option>
                <option value="alteracao-cadastral">Alteração de dados cadastrais (Ex: e-mail, Razão Social, etc.)</option>
                <option value="alteracao-contratual">Alteração contratual</option>
                <option value="socio-prolabore">Prolabore</option>
                <option value="empresa-bloqueada">Bloqueio da empresa</option>
                <option value="outros">Outros</option>
              </select>
              <span class="bar"></span>
              <label for="origemOcorrencia">Origem</label>
            </div>
            <div id="containerOrigemOcorrenciaOutros"></div>
            <template id="tplOrigemOcorrenciaOutros">
                <div class="form-group mb-5">
                  <input type="text" class="form-control" id="origemOcorrenciaOutros" />
                  <span class="bar"></span>
                  <label for="origemOcorrenciaOutros">Texto Outros</label>
                </div>
            </template>
            <div class="form-group">
              <textarea class="form-control" id="ocorrenciaOcorrencia" rows="10"></textarea>
              <span class="bar"></span>
              <label for="ocorrenciaOcorrencia">Ocorrência</label>
            </div>
          </form>
        `;

    const footer = `
            <button type="button" class="btn btn-primary text-white btn-rounded aplicar-ocorrencia cliente" value="${ idEmpresa }">Adicionar Ocorrência</button>
        `;

    showModal(title, body, footer);

    $('input, select, textarea').closest('.form-group').addClass('focused');
  }

  static aplicarOcorrencia($this) {

    $this.prop('disabled', true);

    $('.preloader').show();

    $.ajax({
      type: 'POST',
      url: `/ocorrencias`,
      data: {
        empresa_id: $('#id').val(),
        id_usuario: $('#usuarioOcorrencia').val(),
        status: $('#statusOcorrencia').val(),
        origem: $('#origemOcorrencia').val(),
        origem_outros: $('#origemOcorrenciaOutros').val(),
        ocorrencia: $('#ocorrenciaOcorrencia').val(),
      },
    }).done(response => {
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: `A ocorrência foi adicionada com sucesso.`,
      });
      $('#modal').modal('hide');
    }).fail(response => {
      let errorHTML = response.responseText;

      if (response.status === 412) {

        const errors = (response.responseJSON.errors);

        let messages = [];
        let $firstFocus = null;

        for (let error in errors) {
          if (error === 'ocorrencia') error = 'ocorrenciaOcorrencia';
          if (!$firstFocus) {
            $firstFocus = $(`#${ error }`);
          }
          $(`#${ error }`).closest('.form-group').addClass('invalid-data');
          messages.push(`<li>${ errors[error] }</li>`);
        }

        errorHTML = `
            Não foi possível cadastrar a ocorrência.
            <br>Verifique os campos em vermelho.
          `;

        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: errorHTML,
        });
      }
    }).always(() => {
      $this.prop('disabled', false);
      $('.preloader').hide();
    });
  }

  static getModalAdicionarServico(idEmpresa) {

    const title = `
         <h3>${ escapeHtml($('#nomeTitle').text() || $(`button[value="${ idEmpresa }"]`).closest('TR').find('td').eq(0).text()) }</h3>
         <h6>${ escapeHtml($('#cnpjTitle').text() || $(`button[value="${ idEmpresa }"]`).closest('TR').find('td').eq(1).text()) }</h6>
        `;

    const servicos = window.dadosServicos;
    const optionsServicos = [];
    servicos.forEach(servico => {
        optionsServicos.push(`
        <option value="${ servico.id }">${ escapeHtml(servico.servico) }</option>`,
        );
      },
    );

    const date = new Date();
    const minDate = getDate(addDays(date, 1));

    const body = `
      <form class="floating-labels mt-5 mb-4">
        <div class="form-group mb-5">
          <select class="form-control select2 custom-select p-0" id="servico">
            <option disabled selected>Selecione</option>
            ${ optionsServicos.join('') }
          </select>
          <span class="bar"></span>
          <label for="servico">Serviço</label>
        </div>
        <div class="row">
          <div class="form-group mb-5 col-md-6">
            <input type="date" class="form-control" id="vencimento" min="${ minDate }"
                   value="${ minDate }"
                   data-value="${ minDate }">
            <span class="bar"></span>
            <label for="servico">Vencimento</label>
          </div>
          <div class="form-group mb-5 col-md-6">
            <input type="text" class="form-control money-mask" id="valor">
            <span class="bar"></span>
            <label for="valor">Valor</label>
          </div>
        </div>
        <div class="form-group mb-5">
          <div class="row">
            <div class="col">
              <select class="form-control custom-select p-0" id="recorrente">
                <option value="S">Sim</option>
                <option value="N" selected>Não</option>
              </select>
              <span class="bar"></span>
              <label for="recorrente">Cobrança Recorrente</label>
            </div>
            <div class="form-group mb-5 col-md-6">
              <select class="form-control custom-select p-0" id="parcelamento">
                <option value="1">1x</option>
                <option value="2">2x</option>
                <option value="3">3x</option>
                <option value="4">4x</option>
                <option value="5">5x</option>
                <option value="6">6x</option>
                <option value="7">7x</option>
                <option value="8">8x</option>
                <option value="9">9x</option>
                <option value="10">10x</option>
                <option value="11">11x</option>
                <option value="12">12x</option>
              </select>
              <span class="bar"></span>
              <label for="parcelamento">Parcelamento</label>
            </div>
          </div>
        </div>

        <div class="form-group mb-5">
          <textarea class="form-control" id="observacoes" rows="4"></textarea>
          <span class="bar"></span>
          <label for="observacoes">Observações</label>
        </div>
      </form>
    `;

    const footer = `
        <button type="button" class="btn btn-primary text-white btn-rounded aplicar-servico" value="${ idEmpresa }">Adicionar Serviço</button>
    `;

    showModal(title, body, footer);
    $('.select2-container').css('width', '100%');

    $('input, select, textarea').closest('.form-group').addClass('focused');
  }

  static aplicarServico($this) {

    $this.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: `/servicos`,
      data: {
        empresa_id: $('.aplicar-servico').val(),
        id_servico: $('#servico').val(),
        vencimento: $('#vencimento').val(),
        valor: $('#valor').val(),
        recorrente: $('#recorrente').val(),
        parcelamento: $('#parcelamento').val(),
        observacoes: $('#observacoes').val(),
      },
    }).done(response => {
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: `O serviço foi adicionado com sucesso.`,
      }).then(result => {
        if (result) {
          window.location.reload();
          $('#modal').modal('hide');
        }
      });
    }).fail(response => {
      let errorHTML = response.responseText;

      if (response.status === 412) {

        const errors = (response.responseJSON.errors);

        let messages = [];
        let $firstFocus = null;

        for (let error in errors) {
          if (!$firstFocus) {
            $firstFocus = $(`#${ error }`);
          }
          $(`#${ error }`).closest('.form-group').addClass('invalid-data');
          messages.push(`<li>${ errors[error] }</li>`);
        }

        errorHTML = `
            Não foi possível cadastrar o serviço.
            <br>Verifique os campos em vermelho.
          `;
      }

      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: errorHTML,
      });
    }).always(() => {
      $this.prop('disabled', false);
    });
  }

  static doVerServicos(servicos, $this) {

    let empresa = $('#nomeTitle').text();
    let cnpj = $('#cnpjTitle').text();

    if (!empresa) {
      empresa = $this.closest('tr').find('td').eq(0).text().trim();
      cnpj = $this.closest('tr').find('td').eq(1).text().trim();
    }

    const title = `
     <h3>${ escapeHtml(empresa) }</h3>
     <h6>${ escapeHtml(cnpj) }</h6>
    `;

    const footer = ``;

    const currentDate = new Date();
    const mesAtual = currentDate.getMonth() + 1;
    let anoAtual = currentDate.getFullYear();
    let minAno = anoAtual;

    let totalRecorrentes = 0;
    const servicosRecorrentes = [];

    let totalMes = 0;
    const servicosMes = [];

    let anosOptions = [];

    for (let ano in servicos) {

      anosOptions.push(`<option value="${ ano }" ${ ano == anoAtual ? 'selected' : '' }>${ ano }</option>`);

      if (ano < parseInt(minAno)) {
        minAno = parseInt(ano);
      }

      for (let mes in servicos[ano]) {

        servicos[ano][mes].forEach(servico => {
          if (servico.recorrente === 'S' && servico.mes === mesAtual && parseInt(servico.ano) === anoAtual) {
            totalRecorrentes += parseFloat(servico.valor);
            servicosRecorrentes.push(servico);
          }

          if (servico.recorrente === 'N' && parseInt(servico.mes) === mesAtual && parseInt(servico.ano) === anoAtual) {
            servicosMes.push(servico);
            totalMes += parseFloat(servico.valor);
          }
        });
      }
    }

    anosOptions = anosOptions.reverse();

    const listaServicosRecorrentes = [];
    servicosRecorrentes.forEach(servico => {
      listaServicosRecorrentes.push(`
        <tr>
            <td>
            ${ escapeHtml(servico.servico) }
            </td>
            <td>${ escapeHtml(servico.valor) }</td>
        </tr>
    `);
    });

    const listaServicosMes = [];

    servicosMes.forEach(servico => {
      listaServicosMes.push(`
        <tr>
            <td>${ escapeHtml(servico.servico) }</td>
            <td>${ escapeHtml(servico.valor) }</td>
        </tr>
    `);
    });

    const totalTodosServicos = totalRecorrentes + totalMes;

    const body = `
      <div class="text-center">
        <div class="input-group">
          <div class="input-group-prepend">
            <button type="button" class="btn btn-secondary trocar-mes-servico anterior">
              <span class="mdi mdi-arrow-left-bold"></span>
            </button>
          </div>
          <select class="custom-select" id="mesServico" style="width: 100px!important;">
            ${ buildMeses(mesAtual) }
          </select>
          <select class="custom-select" id="anoServico" style="width: 100px!important;">
            ${ anosOptions.reverse().join('') }
          </select>
          <div class="input-group-append">
            <button type="button" class="btn btn-secondary trocar-mes-servico proximo">
              <span class="mdi mdi-arrow-right-bold"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="py-2">
        <strong>Total do Mês: </strong>
        <input type="text" class="form-control money-mask" id="totalTodosServicos" placeholder="0,00" readonly>
      </div>
      <div class="py-2">
        <strong>Cobranças Recorrentes: </strong>
      </div>
      <table class="table table-bordered mb-1">
        <tbody id="listaServicosRecorrentes">
           ${ listaServicosRecorrentes.join('') }
        </tbody>
        <tfoot>
          <tr>
            <th>Total</th>
            <td><input class="form-control money-mask" placeholder="0,00" id="totalRecorrentes" readonly></td>
         </tr>
        </tfoot>
      </table>
      <div class="py-2">
        <strong>Cobranças para o mês: </strong>
      </div>
      <table class="table table-bordered mb-1">
        <tbody id="listaServicosMes">
            ${ listaServicosMes.join('') }
        </tbody>
         <tfoot>
          <tr>
            <th>Total</th>
            <td><input class="form-control money-mask" placeholder="0,00" id="totalMes" readonly></td>
         </tr>
        </tfoot>
      </table>
    `;

    showModal(title, body, footer);

    $('.modal-dialog').css('max-width', '700px');

    if (totalRecorrentes > 0) {
      $('#totalRecorrentes').val(totalRecorrentes.toFixed(2).toString()).trigger('input');
    }

    if (totalMes > 0) {
      $('#totalMes').val(totalMes.toFixed(2).toString()).trigger('input');
    }

    if (totalTodosServicos > 0) {
      $('#totalTodosServicos').val(totalTodosServicos.toFixed(2).toString()).trigger('input');
    }
  }

  static verServicos($this) {

    $('.preloader').show();

    $.ajax({
      url: `/clientes/${ $this.val() }/servicos`,
    }).done(response => {
      window.servicosCliente = response;
      Empresa.doVerServicos(response, $this);
    }).always(() => {
      $('.preloader').hide();
    });
  }

  static updateMesServico(anterior, $this) {

    const primeiroAno = parseInt($('#anoServico option').eq(0).val());
    const ultimoAno = parseInt($('#anoServico option').eq($('#anoServico option').length - 1).val());

    let mes = parseInt($('#mesServico').val());
    let ano = parseInt($('#anoServico').val());

    if ($this.prop('tagName') === 'BUTTON') {
      if (anterior) {
        mes--;
        if (mes === 0) {
          mes = 12;
          ano--;
        }
      } else {
        mes++;
        if (mes === 13) {
          mes = 1;
          ano++;
        }
      }

      if (ano > ultimoAno) {
        ano = primeiroAno;
      }

      if (ano < primeiroAno) {
        ano = ultimoAno;
      }
    }

    $('#mesServico').val(mes);
    $('#anoServico').val(ano);

    let mesAtual = mes;
    let totalRecorrentes = 0;
    let totalMes = 0;
    let totalServicos = 0;
    let listaRecorrentes = [];
    let listaMes = [];

    const servicos = window.servicosCliente;

    for (let mes in servicos[ano]) {
      servicos[ano][mes].forEach(servico => {
        if (parseInt(servico.mes) === mesAtual) {
          if (servico.recorrente === 'S' && servico) {
            totalRecorrentes += parseFloat(servico.valor);
            listaRecorrentes.push(`
                <tr>
                    <td>
                        <a href="${ window.location.origin }/servicos/${ servico.id }/alterar">
                            ${ escapeHtml(servico.servico) }
                        </a>
                    </td>
                    <td>${ escapeHtml(servico.valor) }</td>
                </tr>
            `);
          } else {
            totalMes += parseFloat(servico.valor);
            listaMes.push(`
                <tr>
                    <td>
                        <a href="${ window.location.origin }/servicos/${ servico.id }/alterar">
                            ${ escapeHtml(servico.servico + (servico.parcela ? ' - ' + servico.parcela : '')) }
                        </a>
                    </td>
                    <td>${ escapeHtml(servico.valor) }</td>
                </tr>
            `);
          }
        }
      });
    }

    $('#listaServicosRecorrentes').html(listaRecorrentes.join(''));
    $('#listaServicosMes').html(listaMes.join(''));

    totalServicos = totalMes + totalRecorrentes;

    if (totalRecorrentes > 0) {
      $('#totalRecorrentes').val(totalRecorrentes.toFixed(2).toString()).trigger('input');
    } else {
      $('#totalRecorrentes').val('');
    }

    if (totalMes > 0) {
      $('#totalMes').val(totalMes.toFixed(2).toString()).trigger('input');
    } else {
      $('#totalMes').val('');
    }

    if (totalServicos > 0) {
      $('#totalTodosServicos').val(totalServicos.toFixed(2).toString()).trigger('input');
    } else {
      $('#totalTodosServicos').val('');
    }
  }

  static excluir($this) {
    Swal.fire({
      icon: 'error',
      title: 'Aviso!',
      html: `Deseja realmente excluir esta empresa?<br>- Embora excluída, alguns dados ainda poderão ser exibidos em relatórios antigos.`,
    }).then(result => {
      if (result) {
        $('.preloader').show();
        $.ajax({
          type: 'DELETE',
          url: `/clientes/${ $this.val() }`,
        }).done(function (response) {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            html: `A empresa foi excluída!`,
          });
          window.location.reload();
        });
      }
    });
  }

  static listen() {

    jQuery(function () {

      loadMasks();

      $(document).on('shown.bs.modal', function (e) {
        const $valorFaturamento = $('#valorFaturamento');
        if ($valorFaturamento.length > 0) {
          $valorFaturamento.focus();
        }
      });

      $(document).on('hidden.bs.modal', function (e) {
        if ($(e.target).prop('id') === 'modalDropzone') {
          console.log('Removing files');
          Dropzone.forElement('#form-anexos').removeAllFiles(true);
        }
      });

      $(document).on('focusin focusout', 'input, textarea, select', function (e) {

        const $this = $(this);

        let action;

        if (e.type === 'focusin') {
          action = 'addClass';
        } else {
          action = $this.prop('type') !== 'date' && (!$this.val() || $this.val().length === 0) ? 'removeClass' : 'addClass';
        }

        $this.closest('.form-group')[action]('focused');
      });

      $(document).on('change', '[type="date"]', function (e) {
        $(this).closest('.form-group').addClass('focused');
      });

      $(document).on('focusout', '#cnpj', function (e) {

        const idEmpresa = +$('#id').val();

        if (idEmpresa > 0) return;

        const cnpj = $(this).val();
        $.ajax({
          url: `${ window.location.origin }/clientes/cnpj/?cnpj=${ encodeURIComponent(cnpj) }`,
        }).done(response => {
          if (response !== 'ok') {
            alert(
              `Este CNPJ já está cadastrado para:\n${ response.razao_social }`,
            );
          }
        }).fail(response => {
          alert('Falha ao consultar o CNPJ');
        });
      });

      $(document).on('click focusin change', '.invalid-data input, .invalid-data select, .invalid-data textarea', function (e) {
        $(this).closest('.form-group').removeClass('invalid-data');
      });

      $(document).on('click', '.adicionar-socio', function (e) {
        Empresa.getModalSocio();
      });

      $(document).on('click', '.alterar-socio', function (e) {
        Empresa.getModalSocio(window.dadosSocios[$(this).data('id')], $(this).data('id'));
      });

      $(document).on('click', '.aplicar-socio', function (e) {
        Empresa.aplicarSocio();
      });

      $(document).on('click', '.excluir-socio', function (e) {
        e.stopImmediatePropagation();
        Empresa.excluirSocio($(this));
      });

      $(document).on('click', '.adicionar-contato', function (e) {
        Empresa.getModalContato();
      });

      $(document).on('click', '.alterar-contato', function (e) {
        Empresa.getModalContato(window.dadosContatos[$(this).data('id')], $(this).data('id'));
      });

      $(document).on('click', '.aplicar-contato', function (e) {
        e.stopImmediatePropagation();
        Empresa.aplicarContato();
      });

      $(document).on('click', '.excluir-contato', function (e) {
        e.stopImmediatePropagation();
        Empresa.excluirContato($(this));
      });

      $(document).on('click', '.adicionar-anexo', function (e) {
        Empresa.getModalAnexo($(this).val(), $(this).data('slug'));
      });

      $(document).on('click', '.excluir-anexo', function (e) {
        e.stopImmediatePropagation();
        Empresa.excluirAnexo($(this));
      });

      $(document).on('click', '.contatos-empresa', function (e) {
        Empresa.getContatos($(this));
      });

      $(document).on('click', '.socios-empresa', function (e) {
        Empresa.getSocios($(this));
      });

      $(document).on('click', '.ver-socio', function (e) {
        Empresa.getSocio($(this));
      });

      $(document).on('click', '.credenciais-empresa', function (e) {
        Empresa.getCredenciais($(this));
      });

      $(document).on('click', '.ocorrencias-empresa, .ver-ocorrencias', function (e) {
        Empresa.getOcorrencias($(this));
      });

      $(document).on('click', '.informacoes-empresa', function (e) {
        Empresa.getInformacaoes($(this));
      });

      $(document).on('click', '.excluir-empresa', function (e) {
        const $this = $(this);
        Empresa.excluir($this);
      });

      $(document).on('submit', '#formCliente', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        Empresa.salvarEmpresa($(this));
      });

      $(document).on('click', '.adicionar-faturamento', function (e) {
        Empresa.getModalAdicionarFaturamento($(this));
      });

      $(document).on('click', '.aplicar-faturamento', function (e) {
        const $this = $(this);
        e.preventDefault();
        Empresa.aplicarFaturamento($this);
      });

      $(document).on('click', '.salvar-faturamentos', function (e) {
        e.stopImmediatePropagation();
        Empresa.salvarFaturamentos();
      });

      $(document).on('click', '.ver-faturamentos', function (e) {
        e.stopImmediatePropagation();
        Empresa.verFaturamentos($(this));
      });

      $(document).on('click change', '.trocar-mes-faturamento, #mesFaturamento, #anoFaturamento', function (e) {
        const $this = $(this);
        const anterior = $this.hasClass('anterior');
        Empresa.updateMesFaturamento(anterior, $this);
      });

      $(document).on('click', '.adicionar-ocorrencia', function (e) {
        const $this = $(this);
        Empresa.getModalAdicionarOcorrencia($this.val());
      });

      $(document).on('click', '.aplicar-ocorrencia.cliente', function (e) {
        e.stopImmediatePropagation();
        const $this = $(this);
        Empresa.aplicarOcorrencia($this);
      });

      $(document).on('click', '.adicionar-servico', function (e) {
        const $this = $(this);
        Empresa.getModalAdicionarServico($this.val());
      });

      $(document).on('click', '.aplicar-servico', function (e) {
        const $this = $(this);
        Empresa.aplicarServico($this);
      });

      $(document).on('click', '.ver-servicos', function (e) {
        e.stopImmediatePropagation();
        Empresa.verServicos($(this));
      });

      $(document).on('click change', '.trocar-mes-servico, #mesServico, #anoServico', function (e) {
        const $this = $(this);
        const anterior = $this.hasClass('anterior');
        Empresa.updateMesServico(anterior, $this);
      });

      function buscaCep($this) {

        const value = $this.val().replace('-', '');

        if (value.length < 8) return false;

        const url = `/busca-cep/${ value }`;
        $('.preloader').show();

        $.getJSON({
          url,
        }).done(response => {
          if (response.resultado === '1') {
            const socio = $this.prop('id') === 'socio_cep' ? '#socio_' : '#';
            $(`${ socio }cidade`).val(response.cidade);
            $(`${ socio }bairro`).val(response.bairro);
            $(`${ socio }estado`).val(response.uf);
            $(`${ socio }endereco`).val(`${ response.tipo_logradouro } ${ response.logradouro }`);
            $(`${ socio }cidade, ${ socio }bairro, ${ socio }estado, ${ socio }endereco`)
              .closest('.form-group').addClass('focused');
          }
        }).fail(response => {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            html: `Erro ao procurar o CEP.`,
          });
        }).always(() => {
          $('.preloader').hide();
        });
      }

      $(document).on('keyup keyup', '#cep, #socio_cep', function (e) {
        e.stopImmediatePropagation();
        buscaCep($(this));
      });

      $(document).on('change', '#recorrente', function () {
        var $parcelamento = $('#parcelamento');
        if ($(this).val() === 'S') {
          $parcelamento.prop('disabled', true);
          $parcelamento
            .closest('.form-group')
            .append(
              '<input type="text" value="Não se aplica" id="parcelamentoHidden" class="form-control" readonly>',
            );
          $parcelamento.hide();
        } else {
          $parcelamento.prop('disabled', false);
          $('#parcelamentoHidden').remove();
          $parcelamento.show();
        }
      });

      $(document).on('change', '#origemOcorrencia', function () {
        const $this = $(this);
        const $container = $('#containerOrigemOcorrenciaOutros');
        const $template = $('#tplOrigemOcorrenciaOutros');
        if ($this.val() === 'outros') {
          $container.html($template.html());
          $('#origemOcorrenciaOutros').focus();
        } else {
          $('#origemOcorrenciaOutros').val('');
          $container.html('');
        }
      });
    });
  }
}

export default Empresa;
